import { USER_INIT } from '../constants/actionTypes.js'

const initialState = {
  logged_in: false,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_INIT:
      return Object.assign({}, state, action.user)
    default:
      return state
  }
}

export default reducer
export { initialState }
